import { CreateOwnerContractData } from '@/custom-types';
import { OwnerContractLeaseTypeOption, PaymentFrequencyOption } from '@/graphql/generated';

export type OwnerContractCreationAction =
  | { type: 'OWNER_CONTRACT-setOwner'; payload: { ownerId: string; ownerName: string } }
  | { type: 'OWNER_CONTRACT-setProperty';  payload: { propertyId: string; propertyName: string } }
  | { type: 'OWNER_CONTRACT-setInsuranceId'; payload: { insuranceId: string | null } }
  | { type: 'OWNER_CONTRACT-setDates'; payload: { startDate: string; finishDate: string } }
  | { type: 'OWNER_CONTRACT-setLeaseType'; payload: { leaseType: OwnerContractLeaseTypeOption } }
  | { type: 'OWNER_CONTRACT-setFrequencyPayment'; payload: { frequencyPayment: PaymentFrequencyOption | null } }
  | { type: 'OWNER_CONTRACT-setContractAmount'; payload: { amount: string } }

export const createOwnerContractReducer = (
  state: CreateOwnerContractData,
  action: OwnerContractCreationAction,
): CreateOwnerContractData => {
  switch (action.type) {
    case 'OWNER_CONTRACT-setOwner':
      return {
        ...state,
        ownerId: action.payload.ownerId,
        ownerName: action.payload.ownerName
      };

    case 'OWNER_CONTRACT-setProperty':
      return {
        ...state,
        propertyId: action.payload.propertyId,
        propertyName: action.payload.propertyName
      };

    case 'OWNER_CONTRACT-setInsuranceId':
      return {
        ...state,
        insuranceId: action.payload.insuranceId,
      };

    case 'OWNER_CONTRACT-setLeaseType':
      return {
        ...state,
        ownerContractLeaseTypeOption: action.payload.leaseType,
      };

    case 'OWNER_CONTRACT-setContractAmount':
      return {
        ...state,
        contractAmount: action.payload.amount,
      };

    case 'OWNER_CONTRACT-setDates':
      return {
        ...state,
        startDate: action.payload.startDate,
        finishDate: action.payload.finishDate,
      };

    case 'OWNER_CONTRACT-setFrequencyPayment':
      return {
        ...state,
        paymentFrequencyOption: action.payload.frequencyPayment,
      };

    default:
      return state;
  }
};
